
// Create array of other-search objects
// Each object takes an array of terms (user input), a new search term, and a new search term type (alternative/correction)
// Alternative type - 'No results for X. You might be interested in Y'
// Correction type - Automatically replaces term with correction
var searchOther = [
  {
    terms : ['opal', 'opa', 'opel'],
    newTerm : 'Moonstone',
    type : 'alternative'
  },
  {
    terms : ['onyx', 'onx', 'onix'],
    newTerm : 'Emerald',
    type : 'alternative'
  },
  {
    terms : ['rose gold init'],
    newTerm : 'Gold initials',
    type : 'alternative'
  },
  {
    terms : ['shell'],
    newTerm : 'Necklaces',
    type : 'alternative'
  },
  {
    terms : ['mini di', 'mini init'],
    newTerm : 'Tiny disc',
    type : 'alternative'
  },
  {
    terms : ['dress'],
    newTerm : 'Heirloom',
    type : 'alternative'
  },
  {
    terms : ['moz', 'moss', 'mosa', 'moisa', 'moiz'],
    newTerm : 'Moissanite',
    type : 'correction'
  },
  {
    terms : ['morh'],
    newTerm : 'Morganite',
    type : 'correction'
  },
  {
    terms : ['mooo', 'monst', 'moost'],
    newTerm : 'Moonstone',
    type : 'correction'
  },
  {
    terms : ['northst', 'norse', 'nirt'],
    newTerm : 'North Star',
    type : 'correction'
  },
  {
    terms : ['cordin', 'co-ordin', 'co ordin'],
    newTerm : 'Coordinates',
    type : 'correction'
  },
  {
    terms : ['praz'],
    newTerm : 'Prasiolite',
    type : 'correction'
  },
  {
    terms : ['hath', 'hawthr'],
    newTerm : 'Hawthorn',
    type : 'correction'
  },
  {
    terms : ['pollish'],
    newTerm : 'Polished',
    type : 'correction'
  },
  {
    terms : ['hugies', 'huggys'],
    newTerm : 'Huggies',
    type : 'correction'
  },
  {
    terms : ['dimon', 'diaman'],
    newTerm : 'Diamond',
    type : 'correction'
  },
  {
    terms : ['saph', 'saf'],
    newTerm : 'Sapphire',
    type : 'correction'
  },
  {
    terms : ['birth ', 'birth stone', 'burt', 'bort'],
    newTerm : 'Birthstone',
    type : 'correction'
  },
  {
    terms : ['sliv', 'solv', 'silb'],
    newTerm : 'Silver',
    type : 'correction'
  },
  {
    terms : ['play'],
    newTerm : 'Gold plated',
    type : 'correction'
  },
  {
    terms : ['rung'],
    newTerm : 'Ring',
    type : 'correction'
  },
  {
    terms : ['me you abd'],
    newTerm : 'You Me & Magic',
    type : 'correction'
  },
  {
    terms : ['forver', 'forevr'],
    newTerm : 'Forever',
    type : 'correction'
  }
];
